import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {Observable, map} from 'rxjs';
import {Signature} from '../models';
import {SignaturePdfFilesService} from '../services/signatureFiles.service';

@Injectable()
export class SignatureResolver {

    constructor(private sigantureService: SignaturePdfFilesService,
                private router: Router) {
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Signature> {
        const id = route.params['id'];
        return this.sigantureService.doc(id).get().pipe(map(
            doc => doc?.data() as Signature
        ));
    }
}
